import { useSelector } from 'react-redux';

import { RootState } from '../reducers';

export const useSearchesState = () => {
  return useSelector((state: RootState) => state.searches);
};